module.exports = __webpack_public_path__ + "img/zip-ic.41cbddae.svg";